const answerServiceName = "/Answer";

export function answerService (http)  {
    return {
        saveAnswerAsync: async (questionId, optionId, userProfileId) => {
            let parameters = {
                questionId,
                optionId,
                userProfileId
            };
            return await http.post(answerServiceName + '/SaveAnswerAsync', parameters);
        },
        saveMultipleAnswersAsync: async (questionId, optionIds, userProfileId) => {
            let parameters = {
                questionId,
                optionIds,
                userProfileId
            };
            return await http.post(answerServiceName + '/SaveMultipleAnswersAsync', parameters);
        },        
        isSavePermitted: (userProfileId, questionId) => {
            let parameters = {
                userProfileId,
                questionId
            };
            return http.post(answerServiceName + '/IsSavePermitted', parameters);
        },
        saveAnswersAsync: async (surveyAnswers) => {
            return await http.post(answerServiceName + '/SaveAnswersAsync', surveyAnswers);
        },
        hasSurveyAlreadyAnswered: (userProfileId, questionId) => {
            let parameters = {
                userProfileId,
                questionId
            };
            return http.post(answerServiceName + '/HasSurveyAlreadyAnswered', parameters);
        },
        haveAllQuestionsAnswered: (userProfileId, questionHeaderId, questionId) => {
            let parameters = {
                questionHeaderId,
                 userProfileId,
                questionId
            };
            return http.post(answerServiceName + '/HaveAllQuestionsAnswered', parameters);
        },        
        getUserAnswers: (userProfileId, questionHeaderId) => {
            let parameters = {
                userProfileId,
                questionHeaderId
            };
            return http.post(answerServiceName + '/GetUserAnswers', parameters);
        },
        getUserAnswer: (userProfileId, questionId) => {
            let parameters = {
                userProfileId,
                questionId
            };
            return http.post(answerServiceName + '/GetUserAnswer', parameters);
        }        
        
        
    }
}